"use client"

import {
    Alert02Icon,
    ArrowReloadHorizontalIcon,
} from "@hugeicons/core-free-icons"
import { HugeiconsIcon } from "@hugeicons/react"
import type { ErrorInfo } from "next/error"
import Link from "next/link"
import { useEffect } from "react"
import { AnimatedThemeToggler } from "@/components/ui/animated-theme-toggler"
import { Button } from "@/components/ui/button"

export default function ErrorPage({ error, retry }: ErrorInfo) {
    useEffect(() => {
        console.error(error)
    }, [error])

    const handleRetry = () => {
        retry()
    }

    return (
        <>
            <div className="fixed top-4 right-4 z-50">
                <AnimatedThemeToggler />
            </div>
            <main className="container mx-auto flex min-h-screen flex-col items-center justify-center px-4">
                <div className="max-w-xl text-center">
                    <div className="mx-auto mb-6 flex size-12 items-center justify-center rounded-full border border-foreground/20">
                        <HugeiconsIcon icon={Alert02Icon} size={20} />
                    </div>
                    <h1 className="mb-4 font-semibold text-3xl tracking-tight sm:text-4xl">
                        Something went wrong
                    </h1>
                    <p className="mb-10 text-muted-foreground">
                        We hit an unexpected error while rendering this page.
                        You can retry now or go back home.
                    </p>
                    <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
                        <Button
                            onClick={handleRetry}
                            className="corner-squircle"
                        >
                            <HugeiconsIcon
                                icon={ArrowReloadHorizontalIcon}
                                className="mr-1 size-4"
                            />
                            Try again
                        </Button>
                        <Button
                            asChild
                            variant="outline"
                            className="corner-squircle"
                        >
                            <Link href="/" transitionTypes={["default"]}>
                                Back home
                            </Link>
                        </Button>
                    </div>
                </div>
            </main>
        </>
    )
}
